// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__O2NxH","left":"InfoRow_left__31RQb"};